import { TableCell } from 'tiptap-extensions'

import { tableNodes } from 'prosemirror-tables'

const TableNodes = tableNodes({
  tableGroup: 'block',
  cellContent: 'block+',
  cellAttributes: {
    border: {
      default: null,
      getFromDOM(dom) {
        return dom.style.border || null
      },
      setDOMAttr(value, attrs) {
        if (value) {
          const style = {
            style: `${attrs.style || ''}border: ${value}`,
          }
          Object.assign(attrs, style)
        }
      },
    },
    background: {
      default: null,
      getFromDOM(dom) {
        return dom.style.backgroundColor || null
      },
      setDOMAttr(value, attrs) {
        if (value) {
          const style = {
            style: `${attrs.style || ''}background-color: ${value};`,
          }
          Object.assign(attrs, style)
        }
      },
    },
  },
})

export default class UpdatedTableCell extends TableCell {
  get schema() {
    return TableNodes.table_cell
  }
}
